import { CELEBRATION_PRESETS, type CelebrationKind } from "./celebrationRules";

/** Brand palette (src/index.css --color-brand-*) plus a warm accent. */
const COLORS = ["#9B7AFF", "#B8A0FF", "#D4C5FF", "#FFC857", "#FFFFFF"];
/** Above Radix dialogs and the transaction modal. */
const Z_INDEX = 10_000;

/**
 * Lazily loaded: canvas-confetti never lands in the entry chunk. The library
 * draws on its own fixed, pointer-events:none canvas and removes it when done.
 */
export async function fireConfetti(kind: CelebrationKind): Promise<void> {
  try {
    const { default: confetti } = await import("canvas-confetti");
    const { intensity, particleCount } = CELEBRATION_PRESETS[kind];
    const base = {
      particleCount,
      colors: COLORS,
      zIndex: Z_INDEX,
      disableForReducedMotion: true,
      ticks: 220,
    };
    if (intensity === "big") {
      void confetti({ ...base, angle: 60, spread: 70, origin: { x: 0, y: 0.7 } });
      void confetti({ ...base, angle: 120, spread: 70, origin: { x: 1, y: 0.7 } });
    } else {
      void confetti({ ...base, spread: intensity === "small" ? 50 : 75, origin: { y: 0.6 } });
    }
  } catch (err) {
    console.debug("[celebrations] confetti unavailable", err);
  }
}
